
import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";
import { LeadAccount } from "@/types/strategy-types";

interface LeadAccountFormActionsProps {
  isSubmitting: boolean;
  onClose: () => void;
  initialData?: LeadAccount;
}

export const LeadAccountFormActions = ({
  isSubmitting,
  onClose,
  initialData
}: LeadAccountFormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2">
      <Button type="button" variant="outline" onClick={onClose} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? (
          <>
            <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            {initialData ? "Updating..." : "Creating..."}
          </>
        ) : (
          initialData ? "Update" : "Create"
        )}
      </Button>
    </div>
  );
};
